import React, { useEffect, useState, useContext } from 'react';
import cn from 'classnames';
import styles from './User.module.sass';
import { UserContext } from '../../../contexts/UserContext';
import ProfileNav from '../ProfileNav';
import ModalAuth from '../ModalAuth';

const User = ({ className }) => {

    const userContext = useContext(UserContext);

    return (
        <div className={cn(styles.user, className)}>
            { userContext.userData.isLogged && <ProfileNav/> }
            <ModalAuth userData={userContext.userData} />
        </div>
    );
};

export default User;
